import { matchesParcelTileFilters } from '../data/parcelFilterMatch';
import { getFeatureLotId } from '../hooks/useLotSelection';

/**
 * ¿La parcela PMTiles cumple el mismo recorte que pinta el mapa con filtros?
 * Alcance y UF oficiales van por id (conjuntos ya armados); el resto, por
 * props del tile, igual que la expresión MapLibre.
 *
 * @param {object} feature
 * @param {{
 *   filters?: Record<string, unknown>|null,
 *   scopeIdSet?: Set<string>|null,
 *   officialUnitLotIdSet?: Set<string>|null,
 * }} [options]
 * @returns {boolean}
 */
export function matchesFilteredParcelFeature(feature, {
  filters = null,
  scopeIdSet = null,
  officialUnitLotIdSet = null,
} = {}) {
  if (scopeIdSet) {
    const lotId = getFeatureLotId(feature);
    if (!lotId || !scopeIdSet.has(String(lotId))) return false;
  }

  if (officialUnitLotIdSet) {
    const lotId = getFeatureLotId(feature);
    if (!lotId || !officialUnitLotIdSet.has(String(lotId))) return false;
  }

  return matchesParcelTileFilters(feature?.properties, filters);
}
